import BaseController from "./BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";

/**
 * Shown to CompuTec staff who signed in with a password: the portal accepts staff only through
 * the Microsoft identity provider (spec 29 D-079).
 * @namespace computec.b2b.portal.controller
 */
export default class StaffLoginRequired extends BaseController {
	public onInit(): void {
		// The button is enabled only when a staff identity provider is configured; otherwise it would be dead.
		const model = new JSONModel({ canStaffLogin: false });
		this.getView().setModel(model, "view");
		void this.getOwnerComponent().bootstrapped.then(() => {
			const hint = this.getOwnerComponent().getOidc()?.staffIdpHint;
			model.setProperty("/canStaffLogin", !!hint);
			if (!hint) {
				console.warn("[Portal] staff sign-in requested but no staff identity provider hint is configured");
			}
		});
	}

	public async onStaffLogin(): Promise<void> {
		const oidc = this.getOwnerComponent().getOidc();
		const hint = oidc?.staffIdpHint;
		if (oidc && hint) {
			try {
				await oidc.loginWithIdentityProvider(hint);
			} catch (error) {
				console.error("[Portal] staff sign-in failed", error);
			}
		} else {
			console.warn("[Portal] staff sign-in ignored: no staff identity provider hint is configured");
		}
	}

	public async onSignOut(): Promise<void> {
		await this.getOwnerComponent().getOidc()?.logout();
	}
}
